// This creates a global "Event Bus" that can be used for sibling components to pass events back and forth.
// In Vue 3, we use mitt for event bus functionality
import mitt from 'mitt';

// Create a simple event bus using mitt
const emitter = mitt();

// Create a Vue 2 compatible API wrapper with proper parameter handling
const bus = {
  $emit: (event, ...args) => {
    console.log('Bus $emit called:', event, args);
    emitter.emit(event, args);
  },
  $on: (event, callback) => {
    console.log('Bus $on registered:', event);
    emitter.on(event, (args) => {
      console.log('Bus $on received:', event, args);
      callback(...args);
    });
  },
  $off: emitter.off.bind(emitter)
};

export default bus;